import "./App.css";
import { Routes, Route, Link } from "react-router-dom";
import HomePage from "./Pages/Homepage";
import ContactSection from "./Pages/Contact";

function App() {
  return (
    <>
    <div>
     <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/contact" element={<ContactSection />} />
      </Routes>
          </div>

    </>
  );
}

export default App;
